// Model.js
// -----------------------
// @module Case
define("Digi.Marketing.Marketing.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/Marketing/SuiteScript2/Marketing.Service.ss"
            ),
            true
        )
});
});
